import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ApplyTelecommutingApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'apply-telecommuting'
  }

}